import React from "react"
import { withStyles } from "@material-ui/core/styles"
import {} from "assets/jss/material-dashboard-react.js"
import { connect } from "react-redux"
import Actions from "redux/actions"
import { withRouter } from "react-router"

class Logout extends React.Component {
  componentDidMount() {
    this.props.dispatch(Actions.logout())
    this.props.history.push("/login")
  }
  render() {
    return null
  }
}

const styles = theme => ({
  container: {},
})

const mapStateToProps = state => ({ fiches: state.reducer.fiches })
export default withRouter(withStyles(styles)(connect(mapStateToProps)(Logout)))
